import React from "react";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
// import "./About.css";



function History() {
  return (
    <div className="about-page">
      <Header />
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Refund & Cancellation</h1>
        </div>
      </header>

      <div className="container my-5">
        <div className="row">
          <div className=" d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
            <h2 className="mb-4 mb-lg-5"> Refund & Cancellation</h2>
            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
            The University Grants Commission receives many representations/complaints from students/parents on the non-refund of fees by the Higher Education Institutions (HEIs) on cancellation/withdrawal of admissions.
              <br />   <br /> 
        

1. Students should be allowed a full refund of fees within a specified period to enable them to opt for a course of their choice.
2. The Commission has considered the matter in its 580th meeting held on 15 May 2024, and after considering the relevant factors decided, the following fee refund policy for the academic session 2024-25.
            </p>

            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
             1. Notwithstanding anything contained in any guidelines/ prospectus/ notification/ schedule, a full refund of fees shall be made by the HEIs on account of all cancellations of admissions/migrations of students up to 30 September 2024 and with a deduction of not more than Rs. 1,000, as a processing fee, up to 31 October 2024.
<br/><br/>
3. It shall apply to all higher education institutions, whether established or incorporated by or under a Central Act or a State Act, and every institution recognized by the University Grants Commission under clause (f) of Section 2 of the University Grants Commission Act, 1956 and to all institutions deemed to be a University declared as such under Section 3 therein and to all higher education institutions affiliated to a University.
              <br /> <br />
4. These guidelines would also be applicable to organizations, consortiums, committees, associations, etc., constituted for the purpose of conducting counselling or processing admissions and collecting fees on behalf of participating HEIS, and the HEI concerned will be responsible for refund fees.
<br/>
5. For any admission schedule extending/commencing beyond/after 31 October 2024, the provisions contained in the UGC Notification issued in October 2018 on Refund of Fees and Non-Retention of Original Certificates shall apply (reproduced below for ready reference)            </p>



            
            

            

       
          </div>
          {/* <div className="col-lg-6 d-flex justify-content-center">
            <img
              src="./img/banner-acm.png"
              className="img-fluid h-25 w-100"
              alt=""
            />
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default History;
